import React from 'react';
import styled from 'styled-components';

import Video from './sections/Video';
import InvestInAmazing from './sections/InvestInAmazing';
import Stories from './sections/Stories';
import Register from './sections/Register';
import vw from 'src/styles/utils';
import Footer from 'components/Footer';

const ThankYou = () => {
  return (
    <Root>
      {/* <MSG>
        <h1>Thank you for registering.
        We look forward to connecting with you soon.</h1>
       
      
      </MSG> */}
      {/* <Logo src={require('src/assets/images/logo.svg')} alt="logo" /> */}

      <Title>
        <p>
        <span>Thank you </span>for registering. <br />
        We look forward to connecting with you soon.
        <nav>
     
        <a href="/">Back to Homepage</a>
      </nav>
        </p>
      <Hero src={require('src/assets/images/hero.jpg')} alt="ig" />
        
      </Title>
      
      <Footer />
    </Root>
  );
};

const Root = styled.main`



`;
const Hero = styled.img`

  width: 100%;
  height: auto;
  
`
const IG = styled.img`

width: 100%;
    height: auto;
`

const Logo = styled.img`
 ${vw('margin-left', 25, 60, 100)}
  ${vw('width', 80, 126)}
  ${vw('height', 140, 221)}
  
`

const Title = styled.h2`
 /* background-image: url(${require('src/assets/images/hero-extened.jpg')});
 background-size: cover;
  
  width:100vw;
  height:100vh; */


 
p{
 
 
  ${vw('padding-top', 50, 75, 100)}
  ${vw('padding-left', 25, 60, 100)}
  ${vw('padding-right', 25, 60, 500)} 
  ${vw('padding-bottom', 50, 75, 100)}
  font-family: Gotham Black;
  font-style: normal;
  font-weight: 900;
  text-transform: uppercase;
  text-align: left;
  ${vw('font-size', 24, 43)}
  ${vw('line-height', 23, 41)}
  ${vw('letter-spacing', 0.2)}
  
  color: #000000;
}
  span {
    color: #DE5647;
  }

  nav {
    /* display: flex;
    justify-content: flex-end; */
    
    ${vw('width', 150, 250, 250)}
    ${vw('margin-top', 25, 30)}
    text-align: center;
  }

  a {
    display: block;
    font-family: Gotham Book;
    font-style: normal;
    font-weight: normal;
    text-transform: capitalize;
    color: #000000;
    cursor: pointer;
    ${vw('font-size', 9, 12)}
    ${vw('line-height', 9, 11)}
    ${vw('padding-top', 11, 17)}
    ${vw('padding-bottom', 11, 17)}

    &:last-of-type {
      font-family: Sharp Sans TRIAL;
      font-weight: bold;
      text-transform: uppercase;
      color: #FFFFFF;
      background: #DE5647;
      ${vw('font-size', 9, 12)}
      ${vw('line-height', 12, 16)}
      ${vw('letter-spacing', 0.72)}
      ${vw('padding-left', 17, 40)}
      ${vw('padding-right', 17, 40)}
    }

    }
  `


export default ThankYou;
